import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';

export function FreePlaces() {
    const [data, setData] = useState(null);

    useEffect(() => { 
        const populateRatings = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'Reference/FreePlaces');
                const data = await response.json(); ; 
                setData(data.spR_SWOBODNI_MESTA);
                //setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        populateRatings();
        document.title = `Свободни места`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.

    //console.log(data);

    return (
        <div>
            <div className="title_rating">Предстоящо класиране -  обявени свободни места</div>
            {/*<div className="no_rating">Няма обявени свободни места.</div>*/}
            

                {!data ? <div className="no_rating"> Няма обявени свободни места.</div> : ( parse(data) )}
                {/*{!data?parse(data):'Няма обявени свободни места.' }*/}
             
        </div>
    );
}

export default FreePlaces;